export default __webpack_public_path__ + "static/media/Drag and drop image from internet.cdb7ea20.mp4";